module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section03_01_beach-photo-0bcc252baa773fba1953a0898330389a.jpg";